'use client'

import { HeroMessagePriceBreakdown } from '@marketplace-web/escrow-pricing/escrow-pricing-feature'
import {
  HeroMessageSellerProtection,
  useUserProtectionVisibility,
} from '@marketplace-web/seller-protection/seller-protection-feature'
import { CurrencyAmountModel } from '@marketplace-web/currency/currency-data'
import { ShipmentStatus } from '@marketplace-web/conversation-shipping/conversation-shipping-data'

interface Props {
  isCorrectUserSide: boolean
  isSellerBusiness: boolean
  itemCount: number
  itemId: number
  price: CurrencyAmountModel
  sellerId?: number
  serviceFee: CurrencyAmountModel
  shipmentStatus?: ShipmentStatus
  thumbnailUrl: string | null | undefined
  title: string
  totalAmountWithoutTax: CurrencyAmountModel
  transactionId: number
  transactionStatus?: number
}

const HeroMessageUserProtection = ({
  isCorrectUserSide,
  isSellerBusiness,
  itemCount,
  itemId,
  price,
  sellerId,
  serviceFee,
  shipmentStatus,
  thumbnailUrl,
  title,
  totalAmountWithoutTax,
  transactionId,
  transactionStatus,
}: Props) => {
  const isSellerProtectionVisible = useUserProtectionVisibility({
    abTestName: 'sale_is_safe_policy_in_conversation_screen',
    isCorrectUserSide,
    isSellerBusiness,
    transactionStatus,
  })

  if (isSellerProtectionVisible) {
    return (
      <HeroMessageSellerProtection
        shipmentStatus={shipmentStatus}
        transactionId={transactionId}
        transactionStatus={transactionStatus}
      />
    )
  }

  return (
    <HeroMessagePriceBreakdown
      isSellerBusiness={isSellerBusiness}
      itemId={itemId}
      itemPrice={price}
      itemTitle={title}
      itemsCount={itemCount}
      sellerId={sellerId}
      serviceFee={serviceFee}
      thumbnailUrl={thumbnailUrl}
      totalAmountWithoutTax={totalAmountWithoutTax}
      transactionId={transactionId}
    />
  )
}

export default HeroMessageUserProtection
